export default __webpack_public_path__ + "static/media/lc.1ebe1fef.jpg";